<template lang="html">
  <div class="container mx-auto px-4">
    <div class="sm:ht-440 bg-1 br-24 flex flex-col items-center justify-center relative">
      <div class="hidden xs:block">
        <img class="ht-full w-full" :src="require('images/blogs/hero_image.png')" />
      </div>
      <div class="block xs:hidden">
        <img class="ht-full w-full" :src="require('images/blogs/hero_image_mobile.png')" />
      </div>
    </div>
    <div class="h-full overflow-y-hidden flex flex-col mt-5 sm:mt-10">
      <div class="flex justify-center md:justify-between items-center flex-wrap">

        <div class="flex justify-between xs:justify-start items-center flex-wrap flex-row">
          <div v-for="(tab, index) in tabs" :key="index" class="w-auto">
            <div class="px-2 xs:px-6 mr-0 md:mr-4 py-2 xs:py-3 flex items-center justify-center rounded-lg xs:rounded-full text-xs xs:text-sm sm:text-base font-light xs:font-semibold" :class="selected_tab==tab.name ? 'rs-filter-btn' : 'cursor-pointer text-mobile-color xs:text-device-color'" @click="selectTab(tab)">{{ tab.name }}</div>
          </div>
        </div>
        <div class="relative block flex-shrink-0 mt-4 lg:mt-0">
          <span class="absolute inset-y-0 left-0 flex items-center pl-3">
              <svg class="h-4 xs:h-5 lg:h-6 w-4 xs:w-5 lg:w-6 fill-black" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30"
                  height="30" viewBox="0 0 30 30">
                  <path
                      d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z">
                  </path>
              </svg>
          </span>
          <input class="w-full bg-white fs-input rounded-lg xs:rounded-full pl-8 lg:pl-10 p-3 border border-darkgrey search-bar xs:search-bar-xs sm:search-bar-sm md:search-bar-md lg:search-bar-lg mt-0 mb-0" type="text" placeholder="Try searching for 'anxiety support'" v-debounce:300ms="search" v-model="search_query"/>
        </div>
      </div>
      <div class="flex-auto flex flex-col overflow-y-auto">
        <div class="flex flex-row flex-wrap mt-10 px-2">
          <div v-for="(blog, index) in blogs" class="w-full xs:w-1/2 sm:w-1/3 lg:w-1/4 px-4 mb-6">
            <blog-card
              :title="blog.attributes.title"
              :index="index"
              :coverImage="blog.attributes.cover_image"
              :cardLink="blog.attributes.blog_url"
              :read_time="blog.attributes.read_time"
            />
          </div>
        </div>

        <infinite-loading class="my-8" :identifier="infiniteId" distance="0" @infinite="loadBlogs">
          <div slot="spinner">
              <blog-loading-card></blog-loading-card>
          </div>
          <template slot="no-more">
            <p class="text-xs text-darkgrey mt-3">No more articles</p>
          </template>
          <template slot="no-results">
            <p class="text-xs text-darkgrey mt-3">No articles</p>
          </template>
        </infinite-loading>
      </div>

    </div> 
  </div>
</template>

<script>
  import BlogFactory from './../../../api/resources/blog';
  import PaginationHeaders from './../../../api/pagination';
  import BlogLoadingCard from './../../../components/loading_cards/blog_card';
  import BlogCard from './../../../components/blogs/blog_card';

  export default {
    mixins: [PaginationHeaders],
    components: {
      BlogLoadingCard,
      BlogCard
    },
    props: {
    },
    computed: {
    },
    data: function() {
      return {
        blogs: [],
        total_blogs: 0,
        page: 1,
        infiniteId: +new Date(),
        search_query: null,
        filter: 'Mental Health',
        tabs: [
          { name: 'Mental Health'},
          { name: 'Relationships'},
          { name: 'Work'},
          { name: 'Body'},
          { name: 'Holistic Wellness'},
        ],
        selected_tab: "Mental Health",
      }
    },
    methods: {
      filterblogs(filter, event) {
        var filters = document.getElementsByClassName('fs-filter');
        for (var i = 0; i < filters.length; i++) {
          filters[i].classList.remove('active')
        }
        event.currentTarget.classList.add('active')

        this.search_query = null
        this.page = 1
        this.filter = filter
        this.infiniteId += 1
      },
      search(query) {
        this.search_query = query
        this.page = 1
        this.blogs = []
        this.infiniteId += 1
      },
      loadBlogs($state) {
        BlogFactory.all(this.search_query, this.page, this.filter).then((response) => {
          if (this.page == 1) {
            this.blogs = response.data.data
            this.total_blogs = response.headers['x-total']
          } else {
            this.blogs = [...this.blogs, ...response.data.data];
          }

          $state.loaded();

          if (response.headers.link) {
            if (this.parse_link_headers(response.headers.link).next) {
              this.page += 1
            } else {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        });
      },

      filterBlogs(filter){
        this.blogs = []
        this.page = 1
        this.filter = filter
        this.infiniteId += 1
      },

      selectTab(tab) {
        this.selected_tab = tab.name;
        this.filterBlogs(tab.name)
      },
    }
  }
</script>

<style lang="scss" scoped>
@responsive {
  .search-bar-lg {
    width: 20rem;
    font-size: 16px;
  }
  .search-bar-md {
    width: 16rem;
    font-size: 13px;
  }
  .search-bar-sm {
    width: 16rem;
    font-size: 13px;
  }
  .search-bar-xs {
    width: 17rem;
    font-size: 14px;
  }
  .search-bar {
    width: 15rem;
    font-size: 12px;
  }
  .ht-440 {
    height: 440px;
  }
  .text-mobile-color {
    color: #8B40E2;
  }
  .text-device-color {
    color: #0a163a;
  }
}


</style>
